import { render } from "./ProjectDonate.vue?vue&type=template&id=19983bfd"
import script from "./ProjectDonate.vue?vue&type=script&lang=js"
export * from "./ProjectDonate.vue?vue&type=script&lang=js"
script.render = render

export default script